module.exports = __webpack_public_path__ + "static/media/pro_4.841eb583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/sections/pro_4.jpg
// module id = 1207
// module chunks = 0